// Copied from the Toolkit (shared/ui/Fold.tsx).
import { useId, useState, type ReactNode } from 'react';

const read = (k: string): boolean | null => { try { const v = localStorage.getItem(k); return v === null ? null : v === '1'; } catch { return null; } };
const write = (k: string, v: boolean) => { try { localStorage.setItem(k, v ? '1' : '0'); } catch { /* private window: not remembered */ } };

// One folding group of a side panel: a header button (name, a short note, a chevron) and its contents.
// With `remember`, the open or closed state is kept in this browser under that key.
export function Fold({ title, note, open: initial = false, remember, children }: { title: ReactNode; note?: ReactNode; open?: boolean; remember?: string; children: ReactNode }) {
  const key = remember && `fold.${remember}`;
  const [open, setOpen] = useState(() => (key ? read(key) : null) ?? initial);
  const id = useId();
  const toggle = () => { setOpen(!open); if (key) write(key, !open); };
  return (
    <section className="fold">
      <h3 className="fold-h">
        <button type="button" aria-expanded={open} aria-controls={id} onClick={toggle}>
          <span className="fold-t">{title}</span>
          {note != null && note !== '' && <span className="fold-n">{note}</span>}
          <svg className="chev" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
        </button>
      </h3>
      <div id={id} className="fold-b" hidden={!open}>{children}</div>
    </section>
  );
}
